import React from "react";
import {RadioButton} from "primereact/radiobutton";
import {CraType} from "../../../constant/Constants";
import LanguageUtil from '../../../util/LanguageUtil';

interface TypeRadioProps {
  value: string;
  onChangeType: (assessor: CraType, resub: boolean) => void;
}

const CraTypeRadioMenu: React.FC<TypeRadioProps> = ({value, onChangeType}) => {

  return (
    <div className="flex flex-row gap-x-4 items-center">
      <div className="flex items-center">
        <RadioButton
          inputId="individual"
          name="type"
          value="Individual"
          checked={value === "Individual"}
          onChange={() => onChangeType("Individual" as CraType, true)}
        />
        <label htmlFor="individual" className="ml-2">
          {LanguageUtil.get({ id: 'common.label.individual', defaultMessage: 'Individual' })}
        </label>
      </div>
      <div className="flex items-center">
        <RadioButton
          inputId="entity"
          name="type"
          value={"Entity"}
          checked={value === "Entity"}
          onChange={() => onChangeType("Entity" as CraType, true)}
        />
        <label htmlFor="entity" className="ml-2">
          {LanguageUtil.get({ id: 'common.label.entity', defaultMessage: 'Entity' })}
          </label>
      </div>
    </div>
  );
};

export default CraTypeRadioMenu;